<div class="document" (click)="openDocumentClicked(document)">
  <i
    class="document__icon"
    [ngClass]="{ 'icon-pdf-outline': isDocumentPDF(document), 'icon-document-outline': !isDocumentPDF(document) }"
  ></i>
  <span class="document__title">{{ document.name }}.{{ document.extension }}</span>
</div>
